var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      class: { "mask-hidden": _vm.isSubDialogOpen },
      on: {
        mousedown: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onCancel.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isSubDialogOpen,
              expression: "!isSubDialogOpen",
            },
          ],
          staticClass: "grouping-dialog",
        },
        [
          _c("div", { staticClass: "grouping-header" }, [
            _c(
              "span",
              {
                staticClass: "grouping-header-edit",
                on: { click: _vm.onClickEdit },
              },
              [_vm._v(_vm._s(_vm.$t("homePage.novelList.grouping.edit")))]
            ),
            _c("span", { staticClass: "grouping-header-title" }, [
              _vm._v(_vm._s(_vm.$t("homePage.novelList.grouping.title"))),
            ]),
            _c(
              "button",
              {
                staticClass: "grouping-close-button",
                on: { click: _vm.onCancel },
              },
              [_c("IconClose", { staticClass: "grouping-close-icon" })],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "grouping-search" },
            [
              _c("IconSearch", { staticClass: "grouping-search-icon" }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchQuery,
                    expression: "searchQuery",
                  },
                ],
                staticClass: "grouping-search-input",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t(
                    "homePage.novelList.grouping.searchPlaceholder"
                  ),
                },
                domProps: { value: _vm.searchQuery },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.searchQuery = $event.target.value
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "grouping-body" },
            [
              _vm.groups.length === 0
                ? [
                    _c("div", { staticClass: "grouping-empty" }, [
                      _c("p", { staticClass: "grouping-empty-message" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("homePage.novelList.grouping.emptyMessage")
                          )
                        ),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "grouping-create-button",
                          on: { click: _vm.onClickCreateGroup },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("homePage.novelList.grouping.createNew")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "grouping-chips" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "grouping-add-button",
                            on: { click: _vm.onClickCreateGroup },
                          },
                          [
                            _c("IconPlus", {
                              staticClass: "grouping-add-icon",
                            }),
                          ],
                          1
                        ),
                        _vm._l(_vm.filteredGroups, function (group) {
                          return _c(
                            "button",
                            {
                              key: group.groupId,
                              staticClass: "grouping-chip",
                              class: {
                                active: _vm.selectedGroupIds.includes(
                                  group.groupId
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleGroup(group.groupId)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(group.name) + " ")]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
            ],
            2
          ),
          _c("div", { staticClass: "grouping-actions" }, [
            _c(
              "button",
              {
                staticClass: "grouping-apply-button",
                on: { click: _vm.onApply },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("homePage.novelList.grouping.apply")) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "grouping-cancel-button",
                on: { click: _vm.onCancel },
              },
              [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }